export default class RetailerEntity {
    constructor (data) {
        return data;
    }

}
